import { ReactNode, useMemo } from 'react';
import { isWebViewUserAgent } from '@contexts/webview-bridge';
import { PUBLIC_PAGE_TOKEN } from '@utils/token/constants';
import { getPublicPageToken } from '@utils/token/get-public-page-token';

import { FeatureFlagContext } from './feature-flag-context';

export const FeatureFlagProvider = ({ children }: { children: ReactNode }) => {
  const isSelectVenueActive = import.meta.env.VITE_SHOW_SELECT_VENUE === 'true';
  const isWebView = isWebViewUserAgent();
  const isXceedAccess = /xceed-access-app/i.test(navigator.userAgent);
  const testCompanyIds = import.meta.env.VITE_TEST_COMPANIES_IDS || '';
  const externalPlatformEnabledIds = import.meta.env.VITE_EXTERNAL_PLATFORM_ENABLED_IDS || '';
  const isExternalPlatformSectionEnabled = import.meta.env.VITE_SHOW_EXTERNAL_PLATFORM_SECTION === 'true';
  const isPublicEventReportPage = !!getPublicPageToken(PUBLIC_PAGE_TOKEN);
  const isUserResetPasswordEnabled = import.meta.env.VITE_SHOW_USER_RESET_PASSWORD === 'true';
  const isOfflineSalesPassScopeEnabled = import.meta.env.VITE_SHOW_OFFLINE_SALES_PASS_SCOPE === 'true';
  const featureFlagContextValues = useMemo(
    () => ({
      isSelectVenueActive,
      isWebView,
      isXceedAccess,
      isPublicEventReportPage,
      testCompanyIds,
      externalPlatformEnabledIds,
      isExternalPlatformSectionEnabled,
      isUserResetPasswordEnabled,
      isOfflineSalesPassScopeEnabled,
    }),
    [
      isSelectVenueActive,
      isWebView,
      isXceedAccess,
      isPublicEventReportPage,
      testCompanyIds,
      externalPlatformEnabledIds,
      isExternalPlatformSectionEnabled,
      isUserResetPasswordEnabled,
      isOfflineSalesPassScopeEnabled,
    ]
  );
  return <FeatureFlagContext.Provider value={featureFlagContextValues}>{children}</FeatureFlagContext.Provider>;
};
